<template>
  <modal
    name="modal--loading"
    transition="nice-modal-fade"
    :click-to-close="false"
    :width="300"
    :height="'auto'"
  >
    <div
      class="flex flex-col text-black h-full bg-white overflow-hidden w-full justify-between p-4"
    >
      <div class="text-center text-4xl tracking-tight">loading...</div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'ModalLoading'
}
</script>
